import message from './message';

/**
 * 설문 응답 데이터 정렬
 * 1. 응답 타입(E - 단독사업자, P - 공동사업자, S - 배우자, F - 가족)
 * 2. 응답 시퀀스(오름차순)
 */
export function responseComparator(a, b) {
  if(a.type === 'E') return -1;
  if(a.type === 'P') {
    if(b.type === 'E') {
      return 1;
    } else if(b.type === 'P') {
      return a.type_seq - b.type_seq;
    } else {
      return -1;
    }
  }
  if(a.type === 'S') {
    if(b.type === 'E' || b.type === 'P') return 1;
    else return -1;
  }
  if(a.type === 'F') {
    if(b.type !== 'F') return 1;
    else return a.type_seq - b.type_seq;
  }
};

/**
 * 설문의 질문 데이터 정렬
 * 1. area : C, I, Q 순 (알파벳 순이라 localeCompare로 비교)
 * 2. sequence : 오름차순
 */
export function questionComparator(a, b) {
  // if(a.area !== b.area) return a.area.localeCompare(b.area);
  return a.sequence - b.sequence;
};

/**
 * lambda함수에서 반환한 에러 코드에 따라 에러 메시지 반환
 * @param {number} status 응답 status 
 * @param {string} errCode Error Code
 * @returns {string} Error Message
 */
export function getErrorMsg(status, errCode) {
  if(status !== undefined && errCode !== undefined) {
    console.error(`${errCode}(${status})`);
  }
  return getMessage('ERROR_' + errCode) || getMessage('ERROR_DEFAULT');
};

export function getTextByType(attendant, lang = 'ko') {
  const { type } = attendant;
  if(lang.toLowerCase() === 'ko') {
    switch(type.toUpperCase()) {
      case 'E': return '단독사업자';
      case 'P': return '공동사업자';
      case 'S': return '비사업배우자';
      case 'F': return '동반가족';
      default: return '기타';
    }
  } else {
    switch(type.toUpperCase()) {
      case 'E': return 'sole';
      case 'P': return 'party';
      case 'S': return 'spouse';
      case 'F': return 'family';
      default: return 'etc';
    }
  }
}

export function getFullTextByType(attendant, lang = 'ko') {
  const { type_seq } = attendant;
  return getTextByType(attendant, lang) + (type_seq || '');
}

/**
 * message.js 에 있는 메시지 반환
 * 
 * key 이외의 나머지 인자로 메시지 부분에 텍스트 삽입
 * @param {String} key 메시지 키값
 * @param  {String[]} args 인덱스 별 삽입 텍스트
 * @returns {String} 메시지
 */
export const getMessage = (key, ...args) => {
  let resultMessage = message[key];

  args && args.forEach((arg, idx) => {
    resultMessage = resultMessage.replace(`{${idx}}`, arg);
  });

  return resultMessage || '';
}